/*                                        */
/**
 *
 */
const noop = (e) => e;
/*        */
/*                                        */
/**
 *
 */
const $effect = Symbol("effect");
/**
 *
 */
const $exec = Symbol("exec");
/**
 *
 */
const $next = Symbol("next");
/**
 *
 *
 *
 *
 *
 */
function fromAsync(value) {
	const res = value;
	res[$exec] = "async";
	res[$next] = (onSucceed, onFail) => fromAsync(res.then((r) => r[$next](onSucceed, onFail)));
	return res;
}
/*        */
/*                               */
/**
 *
 *
 *
 *
 *
 *
 */
function succeed(value) {
	const res = [void 0, value];
	res[$exec] = "sync";
	res[$effect] = "right";
	res[$next] = (onSucceed = noop) => onSucceed(res);
	res.left = void 0;
	res.right = value;
	return res;
}
/**
 *
 *
 *
 *
 *
 *
 */
function fail(error) {
	const res = [error, void 0];
	res[$exec] = "sync";
	res[$effect] = "left";
	res[$next] = (onSucceed, onFail = noop) => onFail(res);
	res.left = error;
	res.right = void 0;
	return res;
}
/**
 *
 *
 *
 *
 *
 *
 */
const some = succeed;
/**
 *
 *
 *
 *
 *
 *
 */
const right = succeed;
/**
 *
 *
 *
 *
 *
 */
const none = () => fail(null);
/**
 *
 *
 *
 *
 *
 *
 */
const left = (leftValue) => fail(leftValue);
/*        */
/*                                       */
/**
 *
 *
 *
 *
 *
 *
 */
var UnknownError = class extends Error {
	/*                                                 */
	name = "UnknownError";
};
/*        */
/*                                      */
/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
const mapErrorPassThrough = (error) => error;
/**
 *
 *
 *
 *
 *
 *
 *
 */
const mapErrorEffectPassThrough = (error) => fail(mapErrorPassThrough(error));
/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
const mapErrorDefault = (error) => new UnknownError(`try handler failed: ${error instanceof Error ? error.message : `${error}`}`, { cause: error });
/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
const mapErrorEffectDefault = (error) => fail(mapErrorDefault(error));
/*        */
/*                                         */
/**
 *
 *
 *
 *
 *
 *
 */
const succeedAsync = (value) => fromAsync(value.then(succeed));
/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
const succeedAsyncWith = (value) => succeedAsync(Promise.resolve(value));
/**
 *
 *
 *
 *
 *
 *
 */
const failAsync = (value) => fromAsync(value.then(fail, fail));
/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
const failAsyncWith = (value) => failAsync(Promise.reject(value));
/**
 *
 *
 *
 */
const coerceFunction = (predicate) => typeof predicate !== "function" ? predicate : predicate();
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const fromCondition = (predicate, rightVal, leftVal) => coerceFunction(predicate) ? succeed(coerceFunction(rightVal)) : fail(coerceFunction(leftVal));
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
function fromNullable(predicate) {
	const value = coerceFunction(predicate);
	return fromCondition(value !== null && value !== void 0, value, value);
}
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
function fromBoolean(predicate) {
	const value = coerceFunction(predicate);
	return fromCondition(value === true, value, value);
}
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
function fromCoerced(rightValue, leftValue) {
	const value = coerceFunction(rightValue);
	return fromCondition(!!value, value, coerceFunction(leftValue));
}
/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
const invert = (effect) => effect[$next]((v) => fail(v[1]), (v) => succeed(v[0]));
/*        */
/*                                  */
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const fromExpression = (effect) => effect;
/**
 *
 *
 *
 *
 *
 *
 *
 */
const syncImmediate = (handler, ...handlerArgs) => succeed(handler(...handlerArgs));
/**
 *
 *
 *
 *
 *
 *
 *
 */
const syncEffectImmediate = (handler, ...handlerArgs) => handler(...handlerArgs);
/**
 *
 *
 *
 *
 *
 *
 *
 */
const promiseImmediate = (handler, ...handlerArgs) => succeedAsync(handler(...handlerArgs));
/**
 *
 *
 *
 *
 *
 *
 *
 */
const promiseEffectImmediate = (handler, ...handlerArgs) => fromAsync(handler(...handlerArgs));
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const trySyncImmediate = (handler, mapErr = mapErrorDefault, ...handlerArgs) => {
	try {
		return succeed(handler(...handlerArgs));
	} catch (error) {
		return fail(mapErr(error));
	}
};
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
function tryPromiseImmediate(handler, mapErr = mapErrorDefault, ...handlerArgs) {
	try {
		return fromAsync(Promise.resolve(handler(...handlerArgs)).then(succeed, (error) => fail(mapErr(error))));
	} catch (error) {
		return failAsyncWith(mapErr(error));
	}
}
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const tryRunSync = (handler, mapErr = mapErrorEffectDefault, ...handlerArgs) => {
	try {
		return succeed(handler(...handlerArgs));
	} catch (error) {
		return mapErr(error);
	}
};
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
function tryRunPromise(handler, mapErr = mapErrorEffectDefault, ...handlerArgs) {
	try {
		return fromAsync(Promise.resolve(handler(...handlerArgs)).then(succeed, mapErr));
	} catch (error) {
		return fromAsync(Promise.resolve(mapErr(error)));
	}
}
/*        */
/*                                 */
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const sync = (handler) => function syncHandler(...a) {
	return succeed(handler.apply(this, a));
};
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const syncEffect = (handler) => handler;
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const promise = (handler) => function promiseHandler(...a) {
	return succeedAsync(handler.apply(this, a));
};
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const promiseEffect = (handler) => function promiseEffectHandler(...a) {
	return fromAsync(handler.apply(this, a));
};
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const trySync = (handler, mapErr) => function trySyncHandler(...a) {
	return trySyncImmediate(() => handler.apply(this, a), mapErr);
};
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const tryPromise = (handler, mapErr) => function tryPromiseHandler(...a) {
	return tryPromiseImmediate(() => handler.apply(this, a), mapErr);
};
/*        */
/*                            */
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const map = (mapper) => ((onSuccess) => (effect) => effect[$next](onSuccess))((e) => succeed(mapper(e[1])));
/**
 *
 *
 *
 *
 */
const mapRight = map;
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const mapAsync = (mapper) => ((onSuccess) => (effect) => effect[$next](onSuccess))((e) => succeedAsync(mapper(e[1])));
/**
 *
 *
 *
 *
 */
const mapRightAsync = mapAsync;
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const mapSpread = (mapper) => ((onSuccess) => (effect) => effect[$next](onSuccess))((e) => succeed(mapper(...e[1])));
/**
 *
 *
 *
 *
 */
const mapRightSpread = mapSpread;
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const mapAsyncSpread = (mapper) => ((onSuccess) => (effect) => effect[$next](onSuccess))((e) => succeedAsync(mapper(...e[1])));
/**
 *
 *
 *
 *
 */
const mapRightAsyncSpread = mapAsyncSpread;
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const flatMap = (mapper) => ((onSuccess) => (effect) => effect[$next](onSuccess))((e) => mapper(e[1]));
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const flatMapSpread = (mapper) => ((onSuccess) => (effect) => effect[$next](onSuccess))((e) => mapper(...e[1]));
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const mapError = (mapper) => ((onFail) => (effect) => effect[$next](void 0, onFail))((e) => fail(mapper(e.left)));
/**
 *
 *
 */
const mapLeft = mapError;
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const mapErrorAsync = (mapper) => ((onFail) => (effect) => effect[$next](void 0, onFail))((e) => failAsync(mapper(e.left)));
/**
 *
 *
 *
 *
 */
const mapLeftAsync = mapErrorAsync;
/*        */
/*                             */
function pipe(...args) {
	switch (args.length) {
		case 2: return args[1](args[0]);
		case 3: return args[2](args[1](args[0]));
		case 4: return args[3](args[2](args[1](args[0])));
		case 5: return args[4](args[3](args[2](args[1](args[0]))));
		case 6: return args[5](args[4](args[3](args[2](args[1](args[0])))));
		case 7: return args[6](args[5](args[4](args[3](args[2](args[1](args[0]))))));
		case 8: return args[7](args[6](args[5](args[4](args[3](args[2](args[1](args[0])))))));
		case 9: return args[8](args[7](args[6](args[5](args[4](args[3](args[2](args[1](args[0]))))))));
		case 10: return args[9](args[8](args[7](args[6](args[5](args[4](args[3](args[2](args[1](args[0])))))))));
		case 1: return args[0];
		case 0: return;
		default: return args.slice(1).reduce((acc, fn) => fn(acc), args[0]);
	}
}
function pipeMap(...args) {
	const onSuccess = (e) => pipe(e, ...args);
	return (effect) => effect[$next](onSuccess);
}
/*        */
/*                              */
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const returnsEffect = (handler) => handler;
/*        */
export { $effect as $, tryRunPromise as A, succeedAsync as B, trySync as C, syncEffectImmediate as D, promiseImmediate as E, fromBoolean as F, mapErrorPassThrough as G, mapErrorDefault as H, fromCoerced as I, left as J, UnknownError as K, fromCondition as L, trySyncImmediate as M, failAsync as N, syncImmediate as O, failAsyncWith as P, succeed as Q, fromNullable as R, tryPromise as S, promiseEffectImmediate as T, mapErrorEffectDefault as U, succeedAsyncWith as V, mapErrorEffectPassThrough as W, right as X, none as Y, some as Z, mapSpread as _, flatMapSpread as a, sync as b, mapAsyncSpread as c, mapLeft as d, $exec as et, mapLeftAsync as f, mapRightSpread as g, mapRightAsyncSpread as h, flatMap as i, tryRunSync as j, tryPromiseImmediate as k, mapError as l, mapRightAsync as m, pipe as n, fromAsync as nt, map as o, mapRight as p, fail as q, pipeMap as r, mapAsync as s, returnsEffect as t, $next as tt, mapErrorAsync as u, promise as v, fromExpression as w, syncEffect as x, promiseEffect as y, invert as z };

/*                                       */